(function() {

  let _ = {}

  _.genRandomString = (length) => {
    let result = ''
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    const charactersLength = characters.length
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  }

  _.alert = function(msg, category='info') {
    const $wrap = document.getElementById('js-alerts')
    const $tmpl = document.getElementById('js-alerts-template')
    let html = $tmpl.innerHTML
    html = html.replace('${msg}', msg)
    html = html.replace('${category}', category)
    let $newMsg = document.createElement('div')
    $newMsg.innerHTML = html
    $wrap.appendChild($newMsg)
  }

  _.appendQueryArgs = function(url, params) {
    const separator = url.includes('?') ? '&' : '?';
    return url + separator + new URLSearchParams(params).toString();
  }

  // Run fn(document.body) once the DOM is ready (or immediately if already
  // parsed). Replaces the former htmx.onLoad hook now that boosted nav is gone.
  _.onReady = function(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => fn(document.body))
    } else {
      fn(document.body)
    }
  }

  _.get = function(selector, el = document) {
    return el.querySelectorAll(selector)
  }

  _.getOne = function(selector, el = document) {
    return el.querySelector(selector)
  }

  _.rollupRemove = function(element) {

    const height = element.offsetHeight;

    const animation = element.animate(
      [
        { height: `${height}px`, opacity: 1 },
        { height: '0px', opacity: 0 }
      ],
      {
        duration: 500,
        easing: 'ease-out',
        fill: 'forwards'  // Keeps final state (opacity: 0) after animation
      }
    );

    // Remove after animation ends
    animation.onfinish = () => {
      element.remove();
    };

  }

  function getConfig () {
    return JSON.parse(_.getOne('#config').textContent)
  }

  _.config = getConfig()

  // Set Sentry user context for the dash bundle
  if (_.config.user && window.Sentry) {
    window.Sentry.setUser({
      id: _.config.user.id,
      username: _.config.user.username,
      email: _.config.user.email,
    })
  }

  // Get current authenticated user info
  _.getCurrentUser = function() {
    return _.config.user || null
  }

  // Check if user is authenticated
  _.isAuthenticated = function() {
    return _.config.user !== null && _.config.user !== undefined
  }


  window._ = _

})();
